/**
 * AMP "See the Difference" — lens comparison widget
 * Uses shop-by-color JSON (sim-0 / sim-1 / colorname / mirrored) + image-simulator.js slider.
 */
(function () {
  'use strict';

  var root = document.getElementById('amp-see-diff');
  if (!root) return;

  var CDN = 'https://cdn.shopify.com/s/files/1/1542/2169/files/';
  var DEFAULT_SKU = 'AMBLP';

  var state = { sku: DEFAULT_SKU };

  function getLensData() {
    if (Array.isArray(window.ampSeeDiffLensData)) return window.ampSeeDiffLensData;
    var el = document.getElementById('amp-see-diff-data');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      window.ampSeeDiffLensData = parsed;
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      console.error('[AMP See Diff] Failed to parse lens data', err);
      return [];
    }
  }

  function getFeaturesData() {
    return window.ampSeeDiffFeaturesData && typeof window.ampSeeDiffFeaturesData === 'object'
      ? window.ampSeeDiffFeaturesData
      : {};
  }

  function findColor(sku) {
    var data = getLensData();
    return data.find(function (c) {
      return c && c._key === sku;
    }) || null;
  }

  function findFeatures(sku) {
    var features = getFeaturesData();
    var needle = ' ' + String(sku).toUpperCase() + ' ';
    for (var key in features) {
      if (Object.prototype.hasOwnProperty.call(features, key) && key.indexOf(needle) !== -1) {
        return features[key];
      }
    }
    return null;
  }

  function setImg(el, filenameOrUrl) {
    if (!el || !filenameOrUrl) return;
    var url = filenameOrUrl.indexOf('http') === 0 || filenameOrUrl.indexOf('//') === 0
      ? (filenameOrUrl.indexOf('//') === 0 ? 'https:' + filenameOrUrl : filenameOrUrl)
      : CDN + filenameOrUrl;
    el.src = url;
    el.setAttribute('data-src', url);
    if (el.hasAttribute('srcset')) el.removeAttribute('srcset');
  }

  function productImageUrl(sku) {
    return CDN + 'lens-' + String(sku).toLowerCase() + '.png';
  }

  function displayTitle(color) {
    var name = (color && color.colorname) || 'Glacier';
    var mirrored = color && String(color.mirrored).toLowerCase() === 'yes';
    return 'Fuse AMP ' + name + (mirrored ? ' Mirror' : '');
  }

  function badgeLabel(color) {
    var name = (color && color.colorname) || 'Glacier';
    return 'AMP ' + name.toUpperCase();
  }

  function render() {
    var color = findColor(state.sku);
    if (!color) return;

    var sim0 = root.querySelector('[data-amp-std="sim-0"]');
    var sim1 = root.querySelector('[data-amp-std="sim-1"]');
    var product = root.querySelector('[data-amp-std="product"]');
    var badge = root.querySelector('[data-amp-std="badge"]');
    var title = root.querySelector('[data-amp-std="title"]');
    var description = root.querySelector('[data-amp-std="description"]');
    var features = findFeatures(state.sku);

    setImg(sim0, color['sim-0']);
    setImg(sim1, color['sim-1']);
    setImg(product, productImageUrl(state.sku));

    if (badge) badge.textContent = badgeLabel(color);
    if (title) title.textContent = displayTitle(color);
    if (description) {
      description.textContent = (features && features.description) || '';
      description.hidden = !description.textContent;
    }

    if (typeof window.updateAttributeBox === 'function') {
      window.updateAttributeBox(state.sku);
    }

    root.querySelectorAll('[data-amp-std-sku]').forEach(function (btn) {
      var on = btn.getAttribute('data-amp-std-sku') === state.sku;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function onSwatchClick(e) {
    var btn = e.target.closest('[data-amp-std-sku]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    var sku = btn.getAttribute('data-amp-std-sku');
    if (!sku || sku === state.sku) return;
    state.sku = sku;
    render();
  }

  root.addEventListener('click', onSwatchClick);
  render();
})();
